export default "__VITE_ASSET__3d03619e__"